import React from 'react'
import i18next from 'i18next'
import { Button, Form, Row, Col } from 'react-bootstrap'

import hash from 'object-hash'
import isEmail from 'validator/lib/isEmail'
import StyledSelect from 'src/components/system_wide/styled_select'
import PlaceSelect from 'src/components/system_wide/places_select'
import SelectBrandModal from 'src/components/system_wide/select_brand_modal'
import CompetenceSelect from 'src/components/system_wide/competence_select'

import { t_caps } from 'src/lib/constants'
import { getConstants } from 'src/lib/constants'
import { Trans } from 'react-i18next'
import ParentModal from './parent_modal'

const { t } = i18next
const usernameRegExp = /^[a-z0-9_-]*$/

class UserForm extends React.Component {
  static defaultProps = {
    is_management: false,
    readonly: false,
    acls: {},
    user: {},
    roles: [],
    competence_areas: [],
    errors: {},
    onSave: () => {},
    closeForm: () => {},
    updateErrors: () => {},
  }

  state = {
    id: null,
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    is_management_account: false,
    business_role_id: null,
    enabled: true,
    caps: {},
    parent_user: null,
    areas_competence: [],
    brands: [],
    user_data: {
      business_name: '',
      pec: '',
      email: '',
      phone: '',
      piva: '',
      cf: '',
      cuu: '',
      address: '',
      city: '',
      province: '',
      cap: '',
      country: '',
      place_id: '',
    },

    user_hash: '',
  }

  refBrandModal = null
  refParentModal = null
  initialHash = ''
  tCaps = getConstants().t_caps

  constructor(props) {
    super(props)
    this.refBrandModal = React.createRef()
    this.refParentModal = React.createRef()
    this.state.caps = Object.keys(t_caps).reduce((acc, k) => ({ ...acc, [k]: false }), {})
    if (props.user.id) {
      let {
        id,
        username,
        first_name,
        last_name,
        email,
        enabled,
        business_role_id,
        is_management_account,
        caps,
        user_data,
        parent_user,
        areas_competence,
        brands,
      } = props.user
      this.state.id = id
      this.state.username = username
      this.state.first_name = first_name
      this.state.last_name = last_name
      this.state.email = email
      this.state.enabled = enabled
      this.state.is_management_account = is_management_account
      this.state.business_role_id = business_role_id
      this.state.user_data = user_data
      this.state.caps = caps
      this.state.parent_user = parent_user || null
      this.state.areas_competence = areas_competence || []
      this.state.brands = brands?.map(b => b.toString()) || []
    }

    // eslint-disable-next-line no-unused-vars
    let { user_hash, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.user_hash = this.initialHash
  }

  componentWillUnmount() {
    this.props.updateErrors({})
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { user_hash, ...rest } = this.state
    this.setState({ user_hash: hash(rest) })
  }

  handleChange = ({ target: { name, value } }) => {
    if (name === 'username' && !usernameRegExp.test(value)) return
    let errors = { ...this.props.errors }
    if (name in errors) {
      delete errors[name]
      this.props.updateErrors({ errors })
    }
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleChangeUserData = ({ target: { name, value } }) => {
    this.setState({ user_data: { ...(this.state?.user_data ?? {}), [name]: value } }, () => this.updateHash())
  }

  handleChangeCheckbox = ({ target: { name } }) => {
    this.setState({ [name]: !this.state[name] }, () => this.updateHash())
  }

  handleSelectChange = (option, { name }) => {
    let newState = { [name]: option ? option.value : null }
    if (name === 'business_role_id') {
      newState.parent_user = null
      newState.brands = []
      newState.caps = this.props.acls[option.value]
    }
    this.setState(newState, () => this.updateHash())
  }

  handledChangePlace = place => {
    let { label, value } = place ?? { label: '', value: '' }
    this.setState({ user_data: { ...this.state.user_data, address: label, place_id: value } }, () => this.updateHash())
  }

  handledChangeCompetenceArea = area => {
    this.setState({ areas_competence: area }, () => this.updateHash())
  }

  handleChangeBrands = brands => {
    this.setState({ brands }, () => this.updateHash())
  }

  showBrandModal = () => {
    this.refBrandModal.current.show()
  }

  handleSaveParent = parent => {
    this.setState({ parent_user: parent }, () => this.updateHash())
  }

  showParentModal = () => {
    let { priority = 0 } = this.props.roles.find(r => r.id === this.state.business_role_id) ?? {}
    this.refParentModal.current.show({
      priority,
      parent_user: this.state.parent_user,
      roles: this.props.roles,
      competence_areas: this.props.competence_areas,
    })
  }

  removeParent = () => {
    this.setState({ parent_user: null }, () => this.updateHash())
  }

  handleConfirm = () => {
    // eslint-disable-next-line no-unused-vars
    let { user_hash, parent_user, ...rest } = this.state
    this.props.onSave({ ...rest, parent_user: parent_user ? parent_user.id : null })
  }

  isFormValid = () => {
    let { username, email, business_role_id, user_data, first_name, last_name, brands } = this.state
    let selected_role = this.props.roles.find(r => r.id === business_role_id)

    return (
      username !== '' &&
      email !== '' &&
      isEmail(email) &&
      (business_role_id !== null || this.props.is_management === true) &&
      (!user_data.email || (user_data.email && isEmail(user_data?.email ?? ''))) &&
      (!user_data.pec || (user_data.pec && isEmail(user_data?.pec ?? ''))) &&
      first_name &&
      last_name &&
      (selected_role.priority !== 4 || brands.length > 0)
    )
  }

  isEmailInvalid = prop => {
    let [group, field] = prop.split('.')
    let current_value = group && field ? this.state?.[group]?.[field] ?? '' : this.state?.[group] ?? ''
    return current_value !== '' && !isEmail(current_value)
  }

  render() {
    let {
      username,
      first_name,
      last_name,
      email,
      enabled,
      business_role_id,
      is_management_account,
      user_data,
      parent_user,
      areas_competence,
      brands,
    } = this.state
    let { errors, readonly, roles } = this.props
    let roleOptions = this.props.roles.map(r => ({ value: r.id, label: r.name }))
    let { priority = 0 } = roles?.find(r => r.id === business_role_id) ?? {}

    let place_selected = { label: user_data.address, value: user_data.place_id }
    let parent_user_selected = parent_user ? `${parent_user?.first_name} ${parent_user.last_name}` : ''
    return (
      <>
        <div className="flex-fill position-relative overflow-auto" style={{ maxHeight: '80vh' }}>
          <div className="w-100 ps-1 pe-4">
            {this.props.is_management && (
              <Form.Group className="mt-3 mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.is_management_user">Utente di servizio</Trans>
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  id="is_management_account"
                  name="is_management_account"
                  checked={is_management_account === true}
                  label={t('components.users.is_management_account', 'Account di servizio')}
                  onChange={this.handleChangeCheckbox}
                  disabled={readonly}
                />
                <Form.Text id="enabledHelp" muted>
                  <Trans i18nKey="components.users.management_user_help">
                    Selezionando questo flag si crea un'utenza di servizio a scopi di manutenzione
                  </Trans>
                </Form.Text>
              </Form.Group>
            )}
            <Form.Group className="mb-3 mt-2">
              <Form.Label>
                <Trans i18nKey="components.users.lock_login_user">Attiva utente</Trans>
              </Form.Label>
              <Form.Check
                type="switch"
                id="enabled"
                name="enabled"
                checked={enabled === true}
                label={t('components.users.lock_user', 'Abilitato')}
                onChange={this.handleChangeCheckbox}
                disabled={readonly}
              />
              <Form.Text id="enabledHelp" muted>
                <Trans i18nKey="components.users.lock_help">
                  Deselezionando questo flag si impedisce l'accesso all'utente
                </Trans>
              </Form.Text>
            </Form.Group>
            <Row>
              <Form.Group as={Col} md={5} sm={12} className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.role">Ruolo</Trans>
                  <span> *</span>
                </Form.Label>
                <StyledSelect
                  name="business_role_id"
                  isClearable
                  placeholder={t('components.users.role', 'Ruolo')}
                  value={roleOptions.find(o => o.value === business_role_id)}
                  onChange={this.handleSelectChange}
                  disabled={readonly}
                  options={roleOptions}
                />
              </Form.Group>
              {priority > 2 && (
                <Col md={7} sm={12}>
                  <Form.Label>
                    <Trans i18nKey="components.users.parent">Supervisore</Trans>
                  </Form.Label>

                  <div className="d-flex flex-row align-items-center">
                    {parent_user_selected !== '' && (
                      <div className="text-muted">
                        {readonly === false && (
                          <i
                            role="button"
                            className="fas fa-times text-center text-danger"
                            onClick={this.removeParent}></i>
                        )}
                        <b>{parent_user?.first_name ?? ''}</b> <b>{parent_user?.last_name ?? ''}</b>
                      </div>
                    )}

                    {readonly === false && (
                      <Button className="ms-2" disabled={business_role_id === null} onClick={this.showParentModal}>
                        <i className="fas fa-plus fa-fw text-start me-0"></i>
                        {parent_user_selected !== '' && <Trans i18nKey="buttons.edit">Modifica</Trans>}
                        {parent_user_selected === '' && <Trans i18nKey="buttons.add">Aggiungi</Trans>}
                      </Button>
                    )}
                  </div>
                </Col>
              )}
            </Row>
            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.username">Username</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="username"
                  placeholder={t('components.users.username', 'Username')}
                  value={username}
                  onChange={this.handleChange}
                  isInvalid={'username' in errors}
                  disabled={readonly}
                />
                <Form.Control.Feedback type="invalid">{errors?.username ?? ''}</Form.Control.Feedback>
                <Form.Text id="usernameHelp" muted>
                  <Trans i18nKey="components.users.username_help">Caratteri permessi: a-z,,0-9,_,-</Trans>
                </Form.Text>
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.email">Email</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="email"
                  placeholder={t('components.users.email', 'Email')}
                  value={email}
                  onChange={this.handleChange}
                  isInvalid={this.isEmailInvalid('email') || 'email' in errors}
                  disabled={readonly}
                />
                <Form.Control.Feedback type="invalid">
                  {'email' in errors && errors?.email}
                  {this.isEmailInvalid('email') && (
                    <Trans i18nKey="components.users.invalid_email">Indirizzo e-mail non valido</Trans>
                  )}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.name">Nome</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="first_name"
                  placeholder={t('components.users.name', 'Nome')}
                  value={first_name}
                  onChange={this.handleChange}
                  disabled={readonly}
                  isInvalid={'first_name' in errors}
                />
                <Form.Control.Feedback type="invalid">{errors?.first_name ?? ''}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.surname">Cognome</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="last_name"
                  placeholder={t('components.users.surname', 'Cognome')}
                  value={last_name}
                  onChange={this.handleChange}
                  disabled={readonly}
                  isInvalid={'last_name' in errors}
                />
                <Form.Control.Feedback type="invalid">{errors?.last_name ?? ''}</Form.Control.Feedback>
              </Form.Group>
            </Row>
            {priority === 4 && (
              <Row>
                <Form.Group as={Col} sm="6" className="mb-3">
                  <SelectBrandModal
                    required={true}
                    selected={brands}
                    onChange={this.handleChangeBrands}
                    readonly={readonly}
                  />
                </Form.Group>
              </Row>
            )}
            <Form.Label as="h5" className="mb-3">
              <Trans i18nKey="components.users.user_data_title">Dettagli</Trans>
            </Form.Label>
            <Form.Group className="mb-3">
              <Form.Label>
                <Trans i18nKey="components.users.business_name">Ragione sociale</Trans>
              </Form.Label>
              <Form.Control
                name="business_name"
                placeholder={t('components.users.business_name', 'Ragione sociale')}
                value={user_data?.business_name ?? ''}
                onChange={this.handleChangeUserData}
                disabled={readonly}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                <Trans i18nKey="components.users.address">Indirizzo</Trans>
              </Form.Label>
              <PlaceSelect selected={place_selected} onChange={this.handledChangePlace} disabled={readonly} />
            </Form.Group>
            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.pec">Pec</Trans>
                </Form.Label>
                <Form.Control
                  name="pec"
                  placeholder={t('components.users.pec', 'Pec')}
                  value={user_data?.pec ?? ''}
                  onChange={this.handleChangeUserData}
                  isInvalid={this.isEmailInvalid('user_data.pec')}
                  disabled={readonly}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.users.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.email">Email</Trans>
                </Form.Label>
                <Form.Control
                  name="email"
                  placeholder={t('components.users.email', 'Email')}
                  value={user_data?.email ?? ''}
                  onChange={this.handleChangeUserData}
                  isInvalid={this.isEmailInvalid('user_data.email')}
                  disabled={readonly}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.users.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>
                <Trans i18nKey="components.users.phone">Telefono</Trans>
              </Form.Label>
              <Form.Control
                name="phone"
                placeholder={t('components.users.phone', 'Telefono')}
                value={user_data?.phone ?? ''}
                onChange={this.handleChangeUserData}
                disabled={readonly}
              />
            </Form.Group>
            <Row>
              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.piva">Partita IVA</Trans>
                </Form.Label>
                <Form.Control
                  name="piva"
                  placeholder={t('components.users.piva', 'Partita IVA')}
                  value={user_data?.piva ?? ''}
                  onChange={this.handleChangeUserData}
                  disabled={readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.cf">Codice fiscale</Trans>
                </Form.Label>
                <Form.Control
                  name="cf"
                  placeholder={t('components.users.cf', 'Codice fiscale')}
                  value={user_data?.cf ?? ''}
                  onChange={this.handleChangeUserData}
                  disabled={readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.users.cuu">Codice univoco</Trans>
                </Form.Label>
                <Form.Control
                  name="cuu"
                  placeholder={t('components.users.cuu', 'Codice univoco')}
                  value={user_data?.cuu ?? ''}
                  onChange={this.handleChangeUserData}
                  disabled={readonly}
                />
              </Form.Group>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>
                <Trans i18nKey="components.users.competence_area">Area di competenza</Trans>
              </Form.Label>
              <CompetenceSelect
                selected={areas_competence}
                onChange={this.handledChangeCompetenceArea}
                disabled={readonly}
              />
            </Form.Group>
          </div>
        </div>
        <div className="border-top pt-2">
          {readonly === false && (
            <Button
              className="float-end"
              variant="primary"
              disabled={!this.isFormValid() || this.initialHash === this.state.user_hash}
              onClick={this.handleConfirm}>
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          )}

          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
        <ParentModal ref={this.refParentModal} onSave={this.handleSaveParent} readonly={readonly} />
      </>
    )
  }
}
export default UserForm
